<template>
  <v-row>
    <v-col cols="12" class="d-flex justify-end">
      <green-text-with-arrow
        :arrowDown="showPriceBreakdown"
        @onClick="showPriceBreakdown = !showPriceBreakdown"
      >
        Price breakdown
      </green-text-with-arrow>
    </v-col>

    <v-expand-transition>
      <v-col cols="12" class="py-0" v-show="showPriceBreakdown">
        <v-row no-gutters class="justify-end my-3">
          <price-breakdown
            :prod-settings-data="prodSettingsData"
            :loading="loading"
            :hasVariants="hasVariants"
            :breakdownCols="5"
            :totalQty="totalQty"
          />
        </v-row>
      </v-col>
    </v-expand-transition>

    <v-col cols="12">
      <v-row no-gutters class="justify-space-between fill-height align-center subtotal">
        <v-col cols="6" class="px-4">
          <span class="subtotal__title pr-2">Total Qty:</span>
          <span class="subtotal__qty pr-2">
            {{ totalQty || 0 }}
          </span>
          <span class="subtotal__min-qty" v-if="showMinQtyInfo && minQty > 1">
            Minimum quantity for this item is {{ minQty }}
          </span>
        </v-col>
        <v-col cols="4" class="px-4 d-flex align-center justify-end">
          <span class="subtotal__title pr-2">Subtotal:</span>
          <span class="subtotal__total-price">
            {{ prodSettingsData.subtotal | priceFilter({
              style: 'currency',
              currency: 'USD'
            }) }}
          </span>

          <v-progress-circular
            v-if="loading"
            indeterminate
            size="14"
            width="2"
            class="ml-2"
          />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import GreenTextWithArrow from '../Panels/common/GreenTextWithArrow'
import PriceBreakdown from '../Panels/common/PriceBreakdown'

export default {
  name: 'RefillSubtotal',
  components: {
    GreenTextWithArrow,
    PriceBreakdown
  },
  props: {
    prodSettingsData: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    hasVariants: {
      type: Boolean,
      required: false,
      default: false
    },
    totalQty: {
      type: [Number, String],
      required: true
    },
    minQty: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data: () => ({
    showPriceBreakdown: false
  }),
  computed: {
    showMinQtyInfo () {
      const { minQty, totalQty } = this
      return totalQty < minQty
    }
  },
}
</script>

<style lang="scss" scoped>
.subtotal {
  height: 55px;
  background-color: #DFF3F2;

  &__title, &__total-price {
    font-family: 'Lato-Bold', sans-serif;
    font-size: 14px;
    line-height: 40px;
    color: #000;
  }

  &__qty {
    font-family: 'Lato-Regular', sans-serif;
    font-size: 15px;
    line-height: 18px;
    color: #4a4a4a;
  }

  &__min-qty {
    font-family: 'Lato-Italic', sans-serif;
    font-size: 15px;
    line-height: 18px;
    color: #F15B5B;
  }

  &__total-price {
    font-size: 16px;
  }
}
</style>
